import { Component, Inject, inject, OnInit } from '@angular/core';
import { Person } from '../../data/person';
import { NonNullableFormBuilder } from '@angular/forms';
import { CrimeDetails } from '../../models/crime-details';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Validators } from '@angular/forms';
import { resolvePersonOption } from '../../../helpers/person.helpers';


@Component({
  selector: 'app-crime-details-dialog',
  templateUrl: './crime-details-dialog.component.html',
  styleUrl: './crime-details-dialog.component.scss'
})
export class CrimeDetailsDialogComponent implements OnInit {

    crimeDetails!: CrimeDetails;
    personOptions: Array<{ value: Person, label: string }> = [];
    formBuilder = inject(NonNullableFormBuilder);
    crimeDetailsForm = this.formBuilder.group({
      offence: [''],
      person: [null as Person | null]
  
    });
  
    constructor(public dialogRef: MatDialogRef<CrimeDetailsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
     this.crimeDetails = data.crimeDetails;
     this.personOptions = data.personOptions;
  
    }

  ngOnInit(): void {


    this.initializeForm();
    this.applyValidators();

  }

  private initializeForm(): void{
    this.crimeDetailsForm.patchValue({
      offence: this.crimeDetails.offence,
      person: resolvePersonOption(this.crimeDetails.person, this.personOptions)
    });

    this.crimeDetailsForm.valueChanges.subscribe(formValue => {
      this.crimeDetails.offence = formValue.offence || '';
      this.crimeDetails.person = formValue.person || new Person();
    });

  }
  
    get dialogTitle(): string {
      return 'Add Criminal Offence';
    }
  
      private applyValidators(): void {
        const offenceControl = this.crimeDetailsForm.controls.offence;
        const personControl = this.crimeDetailsForm.controls.person;
        offenceControl.setValidators([Validators.required]);
        personControl.setValidators([Validators.required]);
        offenceControl.updateValueAndValidity();
        personControl.updateValueAndValidity();
      }


cancel() {
  this.dialogRef.close();
}
ok() {
  if(this.crimeDetailsForm.valid){
      this.dialogRef.close(this.crimeDetails);
    }
    else{
      this.crimeDetailsForm.markAllAsTouched();
      return;
    }
}

}
